export interface ICloseGap {
  id: number;
  measure_code: string;
  measure_description: string;
  member_name: string;
  location_name: string;
  billing_tin: string;
  provider_name: string;
  treated_provider_id: number | null;
  treated_provider_name: string | null;
  somos_provider_id: number;
  created: string;
  complete: boolean;
  app: boolean;
}

export class CloseGap implements ICloseGap {
  id: number;
  measure_code: string;
  measure_description: string;
  member_name: string;
  location_name: string;
  billing_tin: string;
  provider_name: string;
  treated_provider_id: number | null;
  treated_provider_name: string | null;
  somos_provider_id: number;
  created: string;
  complete: boolean;
  app: boolean;

  constructor(data: ICloseGap) {
    Object.assign(this, data);
  }

  static fromObject(data: ICloseGap): CloseGap {
    return new CloseGap(data);
  }

  static fromObjectArray(data: ICloseGap[]): CloseGap[] {
    return data.map(CloseGap.fromObject);
  }
}

export interface IResultClosedGap {
  count: number;
  next: string | null;
  previous: string | null;
  results: ICloseGap[];
}

export class ResultClosedGap implements IResultClosedGap {
  count: number = 0;
  next: string | null = null;
  previous: string | null = null;
  results: CloseGap[] = [];

  constructor(data?: IResultClosedGap) {
    if (data) {
      this.count = data.count;
      this.next = data.next;
      this.previous = data.previous;
      this.results = CloseGap.fromObjectArray(data.results);
    }
  }

  static fromObject(data: IResultClosedGap): ResultClosedGap {
    return new ResultClosedGap(data);
  }
}
